import React from 'react';
import HomeLayout from './HomeLayout';
import { HOMEPAGE_EMPLOYERS } from '../common/constants';

const EmployersLayout = props => {
    return <HomeLayout {...props} subPage={HOMEPAGE_EMPLOYERS} />;
};

export default EmployersLayout;
